var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("breadcrumbs", {
        attrs: {
          two: { path: "/cars", name: this.parent_section_name },
          three: "Автомобиль",
        },
      }),
      _c("div", { staticClass: "main" }, [
        _c("h3", [_vm._v(_vm._s(_vm.page_title))]),
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _vm.loading ? _c("loading") : _vm._e(),
            !_vm.loading
              ? _c(
                  "div",
                  [
                    _c(
                      "el-form",
                      {
                        ref: "addform",
                        staticClass: "demo-ruleForm",
                        attrs: {
                          model: _vm.addform,
                          "label-position": "top",
                          "label-width": "100px",
                          rules: _vm.addformRules,
                        },
                      },
                      [
                        _c(
                          "el-steps",
                          {
                            attrs: {
                              active: _vm.activeStepCarUpload,
                              "finish-status": "success",
                            },
                          },
                          [
                            _c("el-step", {
                              attrs: { title: "Выберите файл PNG" },
                            }),
                            _c("el-step", {
                              attrs: { title: 'Нажмите "Загрузить"' },
                            }),
                            _c("el-step", {
                              attrs: { title: "PNG загружены!" },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { attrs: { gutter: 24 } },
                          [
                            _c(
                              "el-col",
                              {
                                attrs: {
                                  span: 12,
                                  xs: 24,
                                  sm: 24,
                                  md: 12,
                                  lg: 12,
                                  xl: 12,
                                },
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "PNG картинка",
                                      prop: "images",
                                    },
                                  },
                                  [
                                    _c("input", {
                                      ref: "images",
                                      attrs: {
                                        type: "file",
                                        id: "images",
                                        required: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.handleFileUpload2()
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.addform.images
                          ? _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.submitAddForm()
                                      },
                                    },
                                  },
                                  [_vm._v("Загрузить")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }